<script>
  import Header from "./Header.svelte";
  import Main from "./Main.svelte";
  import Footer from "./Footer.svelte";

  import page from "page";
  import { addHours } from "date-fns";
  import { onMount } from "svelte";
  import { qs } from "@parkingboss/utils";

  export let api;

  function validString(start, end) {
    return `${start.toISOString()}/${end.toISOString()}`;
  }

  let propertyId = null;
  let data = new Promise(resolve => {});
  let query = {};

  $: property = data.then(d => d.property);
  $: loadTime = data.then(d => d.property.generated);

  async function loadProperty(id) {
    const now = new Date();
    const valid = validString(addHours(now, -1), addHours(now, 1));

    const loadProperty = api.property(id, false);
    const loadMedias = api.medias(id, { valid });
    const loadPermits = api.permits(id, { valid });

    return {
      property: await loadProperty,
      medias: await loadMedias,
      permits: await loadPermits
    };
  }

  onMount(() => {
    page(function setQuery(ctx, next) {
      query = qs.parse(ctx.querystring);
      next();
    });

    page("/", function discoverLocation() {
      console.warn("Location Discovery not implemented.");
    });

    page("/:propertyId", function setProperty(ctx) {
      if (propertyId != ctx.params.propertyId) {
        propertyId = ctx.params.propertyId;
        data = loadProperty(ctx.params.propertyId);
      }
    });

    page();
  });
</script>

{#if propertyId}
  <Header {property} />
  <Main {data} {query} {propertyId} />
  <Footer {loadTime} />
{:else}
  <main>Detecting your property.</main>
{/if}
